import { gql } from '@/lib/graphql/gql'

export const SEVALLA_CHANGELOG_QUERY = gql`
  query SevallaChangelog {
    sevallaChangelog(page: 1, pageSize: 4) {
      id
      data {
        id
        title
        date
        tags
      }
    }
  }
`
